<template>
    <div>
        <Modal v-model="show"
            :width="1200"
            :footer-hide="true"
            title="现售单明细"
            @on-visible-change="onShowChange">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <Form label-position="top"
                        class="form-input-no-outline">
                        <Row :gutter="16">
                            <Col span="4">
                            <FormItem label="现售单编号">
                                <Input :value="orderRecord.curSaleOrderRecordCode"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="现售单时间">
                                <Input :value="formatDateTimeString(orderRecord.curSaleOrderRecordCreateAt)"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="现售单状态">
                                <Input :value="orderRecord.curSaleOrderRecordOrderStatus"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="3">
                            <FormItem label="客户名称">
                                <Input :value="orderRecord.deliveryAddressContacts"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="3">
                            <FormItem label="联系电话">
                                <Input :value="orderRecord.deliveryAddressPhone"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="5">
                            <FormItem label="收货地址">
                                <Input :value="orderRecord.deliveryAddressFull"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="3">
                            <FormItem label="现售单合计">
                                <Input :value="orderRecord.curSaleOrderRecordTotalOrderCost"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="2">
                            <FormItem label="总件数">
                                <Input :value="orderRecord.curSaleOrderRecordTotalPieces"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="总体积">
                                <Input :value="orderRecord.curSaleOrderRecordTotalVolume"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="总配送费">
                                <Input :value="orderRecord.curSaleOrderRecordStationDeliveryFee"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="总包装费">
                                <Input :value="orderRecord.curSaleOrderRecordTotalPackageFee"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="14">
                            <FormItem label="备注信息">
                                <Input :value="orderRecord.curSaleOrderRecordRemark"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label=" ">
                                <Button type="primary"
                                    @click="printOrder">打印定单</Button>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="24">
                            <FormItem label="现售单商品">
                                <Table ref="mainTable"
                                    :columns="orderDetail.columns"
                                    size="small"
                                    :data="orderDetail.rows"
                                    stripe
                                    border />
                            </FormItem>
                            </Col>
                        </Row>

                        <!-- <Row :gutter="16">
                            <Col span="24"
                                style="text-align:right;">
                            <Button v-if="canDelivery"
                                type="primary"
                                @click="onOrderDelivery">定单发货</Button>
                            </Col>
                        </Row> -->
                    </Form>
                    </Col>
                </Row>
            </Card>
        </Modal>

        <CurSaleOrderDelivery ref="curSaleOrderDeliveryModal" />
    </div>

</template>

<script>
import { formatDateTimeString } from '@/libs/logic';
import CurrencyInput from '@/components/number-input/currency-input';
import DecimalInput from '@/components/number-input/decimal-input';
import CurSaleOrderDelivery from './curSale-order-delivery';
import { getCurSaleOrderDetail, printCurSaleOrderDetail } from '@/api/modules/curSale-management/curSale-order';
import { FILE_SERVER } from '@/api/modules/files';
import { dateRender } from '@/libs/tableRowTimeRender';
import {
    ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID,
    ORDER_PAID_STATUS_TYPE_FULL_PAID
} from '@/view/curSale-management/curSale-order/CurSaleOrderStatus';

export default {
    name: 'CurSaleOrderDetail',
    components: {
        CurrencyInput,
        DecimalInput,
        CurSaleOrderDelivery
    },
    data() {
        return {
            show: false,
            innerSpin: false,
            orderUuid: '',
            curSaleOrderRecordUuid: '',
            pageLoading: false,
            orderRecord: {},
            orderDetail: {
                columns: [
                    { title: '苗场', key: 'seedFarmName', width: 100, align: 'center' },
                    { title: '产品编码', key: 'curSaleOrderDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'curSaleOrderDetailProductName', align: 'center' },
                    { title: '产品形态', key: 'productForm', align: 'center' },
                    { title: '品牌', key: 'brandName', align: 'center' },
                    { title: '单位', key: 'curSaleOrderDetailProductUnit', width: 60, align: 'center' },
                    { title: '批次', key: 'curSaleOrderDetailStoreBatchCode', width: 100, align: 'center' },
                    { title: '销售期限', key: 'curSaleOrderDetailStoreSalePeriod', width: 60, align: 'center' },
                    { title: '批次价格', key: 'curSaleOrderDetailProductDisplayPrice', align: 'center' },
                    { title: '现售单数量', key: 'curSaleOrderDetailOrderQuantity', align: 'center' },
                    { title: '金额', key: 'curSaleOrderDetailTotalDisplayMoney', align: 'center' },
                    // { title: '纸箱单价', key: 'curSaleOrderDetailPackagePrice', align: 'center' },
                    // { title: '纸箱费用', key: 'curSaleOrderDetailPackageTotalMoney', align: 'center' },
                    // { title: '纸箱体积', key: 'curSaleOrderDetailPackageVolume', align: 'center' },
                    // { title: '总体积', key: 'curSaleOrderDetailPackageTotalVolume', align: 'center' },
                    { title: '苗场状态', key: 'curSaleOrderDetailDeliveryType', align: 'center' },
                    { title: '苗场发货量', key: 'curSaleOrderDetailDeliveryQuantity', align: 'center' },
                    { title: '转运站状态', key: 'curSaleOrderDetailStationDeliveryType', align: 'center' },
                    { title: '配送时间', key: 'curSaleOrderDetailStationDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.curSaleOrderDetailStationDeliveryDate) },
                    { title: '转运站发货量', key: 'curSaleOrderDetailCustomerReceiveQuantity', align: 'center' }
                ],
                rows: []
            },
            compensateModal: {
                show: false,
                submitLoading: false,
                form: {
                    orderRecordUuid: '',
                    compensate: 0,
                    remark: ''
                }
            }
        };
    },
    computed: {
        canDelivery() {
            if (this.$checkAccessArray(['B', 'C']) === false) {
                return false;
            }

            const orderRecordPaidStatus = this.orderRecord.curSaleOrderRecordPaidStatus;
            return orderRecordPaidStatus === ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID || orderRecordPaidStatus === ORDER_PAID_STATUS_TYPE_FULL_PAID;
        }
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        formatDateTimeString,
        init() {
            // const query = this.$route.query;
            if (this.orderUuid) {
                this.curSaleOrderRecordUuid = this.orderUuid;

                this.innerSpin = true;
                getCurSaleOrderDetail({ curSaleOrderRecordUuid: this.orderUuid }).then(p => {
                    this.innerSpin = false;
                    if (p.code === 0) {
                        this.orderRecord = p.data.orderDetail.orderRecord;
                        this.orderDetail.rows = p.data.orderDetail.orderDetail;
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        onOrderDelivery() {
            this.$refs.curSaleOrderDeliveryModal.showModal(this.curSaleOrderRecordUuid);
            // this.$router.push({
            //     name: 'cur-sale-order-delivery',
            //     query: {
            //         curSaleOrderRecordUuid: this.curSaleOrderRecordUuid
            //     }
            // });
        },
        printOrder() {
            this.innerSpin = true;
            printCurSaleOrderDetail({ curSaleOrderRecordUuid: this.orderUuid }).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    window.open(FILE_SERVER + res.data.url, "_blank");
                }
            });
        }
    }
};
</script>

<style scoped>
</style>
